var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodolistapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 321,
    viewBox: "0 0 382 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.078 269.084L272.802 274.905L266.981 253.182L251.078 269.084ZM240.216 266.174L202.199 255.987L253.884 204.303L264.07 242.32L240.216 266.174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5891 16.2635C59.6071 7.2814 45.0443 7.28139 36.0622 16.2635L16.2632 36.0624C7.28119 45.0445 7.28119 59.6073 16.2632 68.5893L193.04 245.366L245.366 193.04L68.5891 16.2635Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.731 139.238L361.225 118.732L340.366 139.591L319.506 118.732L299 139.238L319.86 160.097L299 180.957L319.506 201.463L340.366 180.603L361.226 201.463L381.732 180.957L360.872 160.097L381.731 139.238Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.731 20.5061L361.225 0L340.366 20.8595L319.506 7.21216e-06L299 20.5061L319.86 41.3656L299 62.2254L319.506 82.7315L340.366 61.8717L361.226 82.7315L381.732 62.2254L360.872 41.3656L381.731 20.5061Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.617 263.755L299.111 284.261L314.691 299.842L314.581 299.953L335.087 320.459L381.996 273.55L361.49 253.044L335.198 279.336L319.617 263.755Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodolistapp);
export default __webpack_public_path__ + "static/media/todolistapp.b809a3fd825aa4ace1eb9dc06675de30.svg";
export { ForwardRef as ReactComponent };